<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16xGeno/tc-custom/9781681883083.jpg?1728259177738" alt="This image is the cover for the book Favorite Cookies, Williams-Sonoma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Favorite Cookies, Williams-Sonoma
      </h1>
      <p class="bookDescription body article font2">
        <b>Dazzling and delectable cookies for every occasion and taste—from Perfect Chocolate Chip Cookies to Homemade Oreos and Matcha Shortbread Cookies.</b><br/>  <br/> This comprehensive collection of over three dozen cookie recipes provides all the much-loved classics, along with tips and variations on how to make them unique. The recipes are simple enough to be understood by beginning bakers and share a timeless quality that will make them cherished by cooks of all levels. The recipes are the type home cooks will return to again and again.<br/>  <br/> Whether you’re an avid baker or a novice, the experts at the Williams-Sonoma Test Kitchen have you covered. Inside this beautifully photographed volume, you’ll find recipes for all types of cookies, including drop cookies, holiday cookies, sandwich cookies, and bar cookies. Step-by-step photos and instructions illustrate how to roll out dough, cut cookie shapes, and decorate with panache.<br/>  <br/> Drop Cookies: Chocolate Chip; Peanut Butter; Oatmeal Raisin; Cowboy; Coconut, Butterscotch, and Macadamia; Chocolate Crinkle.<br/>  <br/> Holiday Cookies/Gift Giving Cookies: Sugar; Ginger-Molasses; Gingerbread People; Spritz; Snickerdoodle; Candy Cane; Peppermint Bark; Thumbprints; Meringues; Florentines; Almond Crescent.<br/>  <br/> Sandwich Cookies: Chocolate Pretzel-Peanut Butter; Lemon Cream; Homemade Oreos  <br/>  <br/> Bars: Blondie; Toffee Triangles; Peanut Butter Rice Crispy Brownie Bars; 7-Layer Bar; S’mores Brownies; Orange Creamsicle.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Williams-Sonoma Test Kitchen, Annabelle Breakey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cee800ec